module.exports = __webpack_public_path__ + "static/form-4-201d6007ab79abb2474c278fe97fe29c.jpg";